import { render, staticRenderFns } from "./IngresantesCursado.vue?vue&type=template&id=19e10fc6&scoped=true&"
import script from "./IngresantesCursado.vue?vue&type=script&lang=js&"
export * from "./IngresantesCursado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e10fc6",
  null
  
)

export default component.exports